import { jsx as _jsx } from "preact/jsx-runtime";
import styles from '../styles/QuizTitle.module.scss';
const QuizTitle = ({ children, color, id }) => (_jsx("div", Object.assign({ className: styles.title, style: { color }, id: id }, { children: children }), void 0));
export default QuizTitle;
